<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/177Luf1/tc-custom/9781504075176.jpg?1737806636890" alt="This image is the cover for the book Should You Keep a Secret?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Should You Keep a Secret?
      </h1>
      <p class="bookDescription body article font2">
        <b>Two women have learned something shocking about their friend’s husband—and revealing it could either save her or destroy her . . .</b><br/>  <br/> During a night out at the pub, Stella and Carly accept an invitation to a local party, but the scene they find there is not what they expected. It’s a swingers’ event—and their friend Jesse’s husband is there among the swingers.<br/>  <br/> Now the two women aren’t sure what to do. Stella, who works with Jesse at the library, is inclined to keep quiet. She doesn’t want to poke her nose into someone else’s marriage, and on top of that, she knows Jesse is facing a potential job loss. The last thing she needs is more stress. Carly, on the other hand, thinks telling the truth is the right thing to do. Meanwhile, the angry threats from Jesse’s husband warning them to keep their mouths shut only make the situation worse.<br/>  <br/> As the two deal with their own personal lives—Stella facing a marital separation and an ailing mother-in-law, Carly coping with loneliness as her husband works long hours—they find themselves blurting out the shocking news. And even as dark secrets about Jesse’s situation are revealed, Stella and Carly will make some discoveries of their own.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Darcy
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?76a1b3ba